import React, { ReactElement, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import Ellipse10 from "@assets/svg/Ellipse10.svg?react";
import Done from "@assets/svg/Done.svg?react";
import {
  CardContainer,
  TextContainer,
  StepText,
  TitleText,
  DescriptionText,
  ActionButton,
  IconContainer,
} from "./styles/ActivationCard";

interface Props {
  icon: ReactElement<React.SVGProps<SVGSVGElement>>;
  title: string;
  description: string | ReactNode;
  step: string;
  checked: boolean;
  isPhone?: boolean;
  activate?: () => void;
  isDisabled?: boolean;
}

const ActivationCard = ({
  icon,
  title,
  description,
  step,
  checked,
  isPhone = false,
  activate,
  isDisabled,
}: Props) => {
  const { t } = useTranslation();

  return (
    <CardContainer $Done={checked} $isDisabled={isDisabled} $isPhone={isPhone}>
      <TextContainer $isPhone={isPhone}>
        <StepText $isPhone={isPhone}>{step}</StepText>

        <TitleText $Done={checked} $isPhone={isPhone}>
          {checked ? (
            <Done width={isPhone ? 12 : 16} height={isPhone ? 12 : 16} />
          ) : (
            <Ellipse10
              width={isPhone ? 12 : 16}
              height={isPhone ? 12 : 16}
              color={checked ? "#5B3FFF" : undefined}
            />
          )}
          {title}
        </TitleText>

        <DescriptionText $isPhone={isPhone}>{description}</DescriptionText>

        <ActionButton
          disabled={isDisabled}
          $Done={checked}
          $isPhone={isPhone}
          onClick={activate}
          $isDisabled={isDisabled}
        >
          {t("onBoardingJourny.startNow")}
        </ActionButton>
      </TextContainer>

      <IconContainer $isPhone={isPhone}>
        {React.cloneElement(icon, {
          width: isPhone ? 48 : 160,
          height: isPhone ? 48 : 160,
          style: {
            width: "100%",
            height: "auto",
            maxHeight: isPhone ? "48px" : "160px",
          },
        })}
      </IconContainer>
    </CardContainer>
  );
};

export default ActivationCard;
